import { render, staticRenderFns } from "./r-radio.vue?vue&type=template&id=cf12d85e&scoped=true&"
import script from "./r-radio.vue?vue&type=script&lang=js&"
export * from "./r-radio.vue?vue&type=script&lang=js&"
import style0 from "./r-radio.vue?vue&type=style&index=0&id=cf12d85e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf12d85e",
  null
  
)

export default component.exports